const MAKE_WEBHOOK_URL = "https://hook.us2.make.com/9rz3jjxm658mourby24wj3icm83a4e9l";
const UPLOADLIFT_FIELD_NAME = "custom_qr_memory_space_uploads";

(function () {

function getMemoryCodeFromUrl() {
const params = new URLSearchParams(window.location.search);
return (params.get("code") || "").trim();
}

function setMemoryCodeOnPage(code) {
const el = document.getElementById("memory-code-display");
if (!el) return;
el.textContent = code ? ("Memory Code: " + code) : "";
}

function extractFileInfo(evtDetail) {
const d = evtDetail || {};
const fileObj =
d.file ||
d.upload ||
d.asset ||
(d.data && (d.data.file || d.data.upload)) ||
d;

const fileId =
fileObj.id ||
fileObj.file_id ||
fileObj.fileId ||
fileObj.asset_id ||
fileObj.assetId ||
fileObj.key ||
null;

const sizeBytes =
fileObj.size ||
fileObj.size_bytes ||
fileObj.sizeBytes ||
fileObj.bytes ||
(fileObj.file && (fileObj.file.size || fileObj.file.bytes)) ||
null;

const fileName =
fileObj.name ||
fileObj.file_name ||
fileObj.filename ||
(fileObj.file && fileObj.file.name) ||
null;

return {
fileId,
sizeBytes: typeof sizeBytes === "number" ? sizeBytes : (sizeBytes ? Number(sizeBytes) : null),
fileName
};
}

const seen = new Set();

function dedupeKey(action, info) {
const keyPart = info.fileId || info.fileName || JSON.stringify(info);
return action + "::" + keyPart;
}

async function postToMake(payload) {

if (!MAKE_WEBHOOK_URL) return;

try {

await fetch(MAKE_WEBHOOK_URL, {
method: "POST",
headers: { "Content-Type": "application/json" },
body: JSON.stringify(payload)
});

console.log("[SmartJewelry] Sent to Make:", payload);

} catch (err) {

console.error("[SmartJewelry] Failed:", err);

}

}

const memoryCode = getMemoryCodeFromUrl();
setMemoryCodeOnPage(memoryCode);

function handleUploadEvent(action, e) {

const info = extractFileInfo(e?.detail);
const key = dedupeKey(action, info);

if (seen.has(key)) return;
seen.add(key);

const payload = {
action,
memoryCode,
uploadLiftField: UPLOADLIFT_FIELD_NAME,
fileId: info.fileId || "",
fileName: info.fileName || "",
sizeBytes: info.sizeBytes || 0,
pageUrl: window.location.href,
ts: new Date().toISOString()
};

postToMake(payload);

}

window.addEventListener("upload:added", e => handleUploadEvent("upload_added", e));
window.addEventListener("upload:removed", e => handleUploadEvent("upload_removed", e));

console.log("[SmartJewelry] Upload listener active. MemoryCode:", memoryCode);

})();
document.addEventListener("DOMContentLoaded", function () {
  const btn = document.getElementById("finish-lock-space-btn");
  if (!btn) return;

  btn.addEventListener("click", async function () {
    const params = new URLSearchParams(window.location.search);
    const memoryCode = (params.get("code") || "").trim();

    if (!memoryCode) {
      alert("Memory Code not found.");
      return;
    }

    try {
      console.log("Sending Finish & Lock to Make...", {
        action: "finish_lock_space",
        memoryCode: memoryCode
      });

      const res = await fetch(MAKE_WEBHOOK_URL, {
      redirect: "manual", 
       method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          action: "finish_lock_space",
          memoryCode: memoryCode,
          pageUrl: window.location.href,
          ts: new Date().toISOString()
        })
      });

      const text = await res.text();
      console.log("Finish & Lock response:", res.status, text);

      if (!res.ok) {
        alert("Lock request reached Make but returned an error.");
        return;
      }

      alert("Your Memory Space has been submitted.");
    } catch (err) {
      console.error("Finish & Lock failed:", err);
      alert("There was a problem locking the space.");
    }
  });
});